import { render, staticRenderFns } from "./PrinterLimitsCard.vue?vue&type=template&id=771890c8&"
import script from "./PrinterLimitsCard.vue?vue&type=script&lang=ts&"
export * from "./PrinterLimitsCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports